import React, { Suspense } from 'react';

const LazyGameRoutes = React.lazy(() =>
  import(/* webpackChunkName: "game-routes" */ 'components/game-routes/routes'),
);

export default function GameRoutes() {
  return (
    <Suspense fallback={null}>
      <LazyGameRoutes />
    </Suspense>
  );
}
